import { IDeleteResponseProps } from '.';

export class DeleteResponse implements IDeleteResponseProps {
  errorCode = '';
  formattedMessage = '';
  isSuccess = false;

  public static fromJson = (data: DeleteResponse): DeleteResponse => {
    const model = new DeleteResponse();
    model.errorCode = data.errorCode;
    model.formattedMessage = data.formattedMessage;
    model.isSuccess = data.isSuccess;
    return model;
  };
}
